export enum Action {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
  DOWNLOAD = 'download',
  DELETE = 'delete',
}

export type PaginatedResponse<T, K = null> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
  summary?: K;
  total_stock_value?: number;
};

export type Years = {
  years: number[];
};

export interface SidebarMenuItem {
  label: string;
  icon: string;
  route?: string;
  click?: () => void;
  module?: string;
  /** Visible to admins only, for screens the backend gates on IsAdminUser rather than a permission code. */
  adminOnly?: boolean;
}

/** A titled block of sidebar links. An empty title renders the items with no header. */
export interface SidebarMenuGroup {
  title: string;
  items: SidebarMenuItem[];
}

export interface TableColumn<T> {
  label: string;
  field?: keyof T | string;
  format?: (value: any, row: T) => string;
  width?: string;
  btn_type?: string;
}

export enum Status {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  PAID = 'paid',
}

export enum UserRole {
  ADMIN = 'admin',
  PRODUCTION_MANAGER = 'Production Manager',
}

export interface TabItem {
  label: string;
  icon?: string;
  value: string;
  badge?: string | number;
  visible?: boolean; // Optional, for role-based or conditional visibility
  roles?: string[]; // Optional, for role-based visibility
  permissionCode?: string; // e.g. ui.tab_orders_dispatched.view
}

export enum FirmType {
  SOLE_PROPRIETORSHIP = 'sole_proprietorship',
  PARTNERSHIP_FIRM = 'partnership_firm',
  LLP = 'limited_liability_partnership',
  PRIVATE_LIMITED = 'private_limited_company',
  PUBLIC_LIMITED = 'public_limited_company',
  OPC = 'one_person_company',
  CO_OPERATIVE_SOCIETY = 'co_operative_society',
  TRUST_SOCIETY = 'trust_society',
}

export const FirmTypeLabel: Record<FirmType, string> = {
  [FirmType.SOLE_PROPRIETORSHIP]: 'Sole Proprietorship',
  [FirmType.PARTNERSHIP_FIRM]: 'Partnership Firm',
  [FirmType.LLP]: 'Limited Liability Partnership (LLP)',
  [FirmType.PRIVATE_LIMITED]: 'Private Limited Company',
  [FirmType.PUBLIC_LIMITED]: 'Public Limited Company',
  [FirmType.OPC]: 'One Person Company (OPC)',
  [FirmType.CO_OPERATIVE_SOCIETY]: 'Co-operative Society',
  [FirmType.TRUST_SOCIETY]: 'Trust / Society',
};

export enum DesignationEnum {
  REGIONAL_SALES_MANAGER = 'Regional Sales Manager',
  SALES_OFFICER = 'Sales Officer',
  TERRITORY_SALES_MANAGER = 'Territory Sales Manager',
  AREA_SALES_MANAGER = 'Area Sales Manager',
  MARKET_DEVELOPMENT_OFFICER = 'Market Development Officer',
  BUSINESS_DEVELOPMENT_MANAGER = 'Business Development Manager',
  DISPATCH_HEAD_AKOLA_DEPO = 'Dispatch Head-Akola Depo',
  HR_AND_ACCOUNTS_HEAD = 'HR & Accounts Head',
  BILLING_AND_DISPATCH_HEAD = 'Billing & Dispatch Head',
  PRODUCTION_MANAGER = 'Production Manager',
  FACTORY_SUPERVISOR = 'Factory Supervisor',
}
